import { useCallback, useEffect, useRef } from 'react';
import { info as logInfo, error as logError, warning as logWarning, Properties } from './logger';
import { useLogContext } from './LogProvider';

type Logging = {
  info: (message: string, properties?: Properties) => void;
  warning: (message: string, properties?: Properties) => void;
  error: (error: Error, properties?: Properties) => void;
};

function useLogging(): Logging {
  const context = useLogContext();
  const logContextRef = useRef(context);

  useEffect(() => {
    logContextRef.current = context;
  }, [context]);

  const info = useCallback((message: string, properties?: Properties) => {
    logInfo(message, { ...(logContextRef.current ?? {}), ...properties });
  }, []);

  const warning = useCallback((message: string, properties?: Properties) => {
    logWarning(message, { ...(logContextRef.current ?? {}), ...properties });
  }, []);

  const error = useCallback((err: Error, properties?: Properties) => {
    logError(err, { ...(logContextRef.current ?? {}), ...properties });
  }, []);

  return {
    info,
    warning,
    error,
  };
}

export { useLogging };
